import { render, staticRenderFns } from "./PostBlockGroup.vue?vue&type=template&id=60afeec8&scoped=true&"
import script from "./PostBlockGroup.vue?vue&type=script&lang=js&"
export * from "./PostBlockGroup.vue?vue&type=script&lang=js&"
import style0 from "./PostBlockGroup.vue?vue&type=style&index=0&id=60afeec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afeec8",
  null
  
)

export default component.exports